import { MutationKeyConfig, QueryKeyConfig } from './api-helper';

export interface WOReportRequestArgs {
  projectID?: number;
  officeID?: number;
  customerID?: number;
  unitID?: number;
  municipalityId?: number;
  cocStatus?: string;
  wOStatusID?: number;
  dateFrom?: string;
  dateTo?: string;
}

const getWOReportWithFilters = (filter: WOReportRequestArgs) => {
  const { customerID, officeID, projectID, unitID, municipalityId, cocStatus, dateFrom, dateTo } = filter;

  let queryString = '';

  if (customerID) {
    queryString += `${queryString ? '&' : ''}CustomerID=${customerID}`;
  }
  if (officeID) {
    queryString += `${queryString ? '&' : ''}OfficeID=${officeID}`;
  }
  if (projectID) {
    queryString += `${queryString ? '&' : ''}ProjectID=${projectID}`;
  }
  if (unitID) {
    queryString += `${queryString ? '&' : ''}UnitID=${unitID}`;
  }
  if (municipalityId) {
    queryString += `${queryString ? '&' : ''}MunicipalityId=${municipalityId}`;
  }
  if (cocStatus) {
    queryString += `${queryString ? '&' : ''}CocStatus=${cocStatus}`;
  }
  if (dateFrom) {
    queryString += `${queryString ? '&' : ''}DateFrom=${dateFrom}`;
  }
  if (dateTo) {
    queryString += `${queryString ? '&' : ''}DateTo=${dateTo}`;
  }
  return queryString;
};

export const cocReportApiKeyStore = {
  getCocReports: (args: WOReportRequestArgs): QueryKeyConfig => ({
    queryKey: [
      `GET_COC_REPORTS`,
      [
        args.customerID,
        args.officeID,
        args.projectID,
        args.unitID,
        args.municipalityId,
        args.dateFrom,
        args.dateTo,
        args.cocStatus,
      ].filter((a) => a),
    ],
    route: `/Unit/DuxCocReport?${getWOReportWithFilters(args)}`,
  }),
  getCocReportStatus: (): QueryKeyConfig => ({
    queryKey: [`GET_COC_REPORT_STATUS`],
    route: `/Unit/CoCReport/CoCStatus`,
  }),
  uploadCocFile: (): MutationKeyConfig => ({
    mutationKey: [`UPLOAD_COC_FILE`],
    route: `/File/UploadCocDocument`,
    action: 'POST',
  }),
  getCocBillingReports: (args: WOReportRequestArgs): QueryKeyConfig => ({
    queryKey: [
      `GET_COC_REPORTS`,
      [
        args.customerID,
        args.officeID,
        args.projectID,
        args.unitID,
        args.municipalityId,
        args.dateFrom,
        args.dateTo,
        args.cocStatus,
      ].filter((a) => a),
    ],
    route: `/Unit/DuxCocBillingReport?${getWOReportWithFilters(args)}`,
  }),

  duxCocMailSend: (id: number): MutationKeyConfig => ({
    mutationKey: [`UPLOAD_COC_FILE`, id],
    route: `/Unit/DuxCocMailSend/${id}`,
    action: 'POST',
  }),
};
